<template>
  <div class="mb-3" v-if="isAuthenticated && isAdmin">
    <div class="container pt-3">
      <router-view></router-view>
    </div>
  </div>
  <div v-else-if="isAuthenticated && !isAdmin" class="container pt-3">
    <b-alert show variant="danger">
      <h4 class="alert-heading">Access Denied</h4>
      <p>You do not have permission to access the admin area.</p>
      <hr>
      <p class="mb-0">
        <router-link :to="{ name: 'ProfileStats' }">Return to your profile</router-link>
      </p>
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminShow",
  computed: {
    ...mapGetters({
      isAuthenticated: "user/auth/isAuthenticated",
      isAdmin: "user/profile/isAdmin",
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
